// extracted by mini-css-extract-plugin
export var required = "_f2-0";